import { APIError } from './APIError';
export class InvalidResponseError extends APIError {
    constructor(message) {
        const errorMessage = message !== null && message !== void 0 ? message : 'Invalid response: missing `data` property from response';
        super(errorMessage);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
